import * as Yup from 'yup'
import React, { useState, useEffect, useRef } from 'react'
import {
  GoogleMap,
  LoadScript,
  InfoWindow,
  DirectionsRenderer,
  Marker,
} from '@react-google-maps/api'
import LocationDetails from './LocationDetails'
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill'
import {
  currentFacilityId,
  defaultZipCode,
  GOOGLE_API_KEY,
  MAPBOX_ACCESS_TOKEN,
  PUBNUB_PUBLISH_KEY,
  PUBNUB_SECRET_KEY,
  PUBNUB_SUBSCRIBE_KEY,
  REST_API,
  REST_API_END_POINT,
} from 'src/constants/Defaultvalues'
import mapboxgl from 'mapbox-gl'
mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN
import PubNub from 'pubnub'
import axios from 'axios'
import { Form, FormikProvider, useFormik } from 'formik'
import {
  Box,
  Card,
  Grid,
  Stack,
  TextField,
  Button,
  Autocomplete,
  Typography,
  CardContent,
  Tab,
  Tabs,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Chip,
  Avatar,
  Divider,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Popover,
  Tooltip,
} from '@material-ui/core'
import { LoadingButton, TabContext, TabList, TabPanel } from '@material-ui/lab'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'
import LoadingScreen from 'src/components/LoadingScreen'
import { useSnackbar } from 'notistack'
import { Close, Delete, KeyboardBackspaceOutlined, Place, Refresh, WorkOutline, PersonOutline, Business, Receipt } from '@material-ui/icons'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import homeIcon from '../../../src/assets/active-routes-home.png'
import { Block } from '../components-overview/Block'
import MapComponent from './TrackDriver'
import { MButtonGroup } from 'src/components/@material-extend'

import truckIcon from 'src/assets/delivery.svg'
import installationIcon from 'src/assets/2jKMY8AFOqiToSHy1XkhiN26QCc.svg'
import car from 'src/assets/car-removebg-preview.png'
import truck from 'src/assets/semi.png'
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import Scrollbar from 'src/components/Scrollbar'
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs'
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup'
import Icon from '@iconify/react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick'
import moment from 'moment'
import { start } from 'nprogress'
import MapBoxComponent from './MapComponent'
import { mapboxDirections } from 'src/utils/decodePolyline'





function calculateDistance(p1, p2) {
  const R = 6371; // Radius of Earth in km
  const dLat = ((p2.lat - p1.lat) * Math.PI) / 180;
  const dLon = ((p2.lng - p1.lng) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((p1.lat * Math.PI) / 180) *
      Math.cos((p2.lat * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function tspSolver(locations, startPoint) {
  const visited = new Array(locations.length).fill(false);
  const route = [];
  let current = startPoint;

  for (let i = 0; i < locations.length; i++) {
    let nearest = -1;
    let minDist = Infinity;
    for (let j = 0; j < locations.length; j++) {
      if (!visited[j]) {
        const dist = calculateDistance(current, locations[j]);
        if (dist < minDist) {
          minDist = dist;
          nearest = j;
        }
      }
    }
    visited[nearest] = true;
    route.push(locations[nearest]);
    current = locations[nearest];
  }

  return route;
}


const MapComponent2 = ({
  allAttachments,
  driverDataaa,
  home,
  details,
  selectedSalesOrder,
  setSelectedSalesOrder,
  selectedRoute,
  setSelectedRoute,
  locations,
  setLocations,
  directions,
  setDirections,
  getLatandLongFromAddress,
  selectedData,
  isFromPs,
  locationDetails,
  requestProducts,
  setRquestProducts,
  additionalSelectedServices,
  setAdditionalSelectedServices,
  selectedRfpServices,
  selectedRfpProduct,
  setSelectedRfpProduct,
  setSelectedRfpServices,
  render
}) => {
  const [markers, setMarkers] = useState([])
  const [apiLoaded, setApiLoaded] = useState(false)
  const [selectedMarker, setSelectedMarker] = useState(null)
  const [selectedDriverId, setSelectedDriverId] = useState(null)
  const [selectedDriver, setSelectedDriver] = useState(null)
  const [selectProject, setSelectProject] = useState(null)
  const [isDriver, setIsDriver] = useState(false)
  const [selectedTeam, setSelectedTeam] = useState(null)
  const [selectTemplate, setSelectTemplate] = useState(null)
  const [templates, setTemplates] = useState([])
  const [salesOrderData, setSalesOrderData] = useState([])
  const [routeData, setRouteData] = useState([])
  // const [locations, setLocations] = useState([]);
  // const [directions, setDirections] = useState([]);
  const [originalDriverId, setOriginalDriverId] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingTeam, setLoadingTeam] = useState(false)
  const [previosSalesOrderId, setPreviosSalesOrderid] = useState(null)
  const navigate = useNavigate()
  const [selectedOriginalDriverId, setSelectedOriginalDriverId] = useState(null)
  const [updatedRoute, setUpdatedRoute] = useState(false)
  const [allAppointmentData, setAllAppointmentData] = useState([])
  const [teamMembers, setTeamMembers] = useState([])
  const [addedLocations, setAddedLocations] = useState([])
  const [deleteLocationIndex, setDeleteLocationIndex] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [allProducts, setAllproducts] = useState([])
  const [selectedProducts, setSelectedProducts] = useState([])
  const [tooltipInfo, setTooltipInfo] = useState([])
    const [markerPopup, setMarkerPopup] = useState({ open: false, location: null })
    const [mapOrderData,setMapOrderData] = useState([])

  const [debouncedFetch, setDebouncedFetch] = useState(false);
  // const [geocoder] = useState(new window.google.maps.Geocoder());
  const { enqueueSnackbar } = useSnackbar()
  const userData = JSON.parse(window.localStorage.getItem('user'))
  const userId = userData.user_id

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const popoverTimer = useRef(null);
  const hoverTimeout = useRef(null); 
  const [isSaving, setIsSaving] = useState(false);

    let explodedPermissions = userData?.exploded_permissions
const hasRouteMovingPermission = (explodedPermissions?.some((permission) =>
['Route Management (Route Map)'].includes(permission), ) && (!details?.allInstallationCompleted && details?.installationCompleteStatus == null) )? true : false
console.log('hasRouteMovingPermission 1', hasRouteMovingPermission)




const handleMarkerClick = (location, mousePos) => {
  setSelectedLocation(location)
  setMousePosition(mousePos)   // if you still position pop-over by cursor
  setMarkerPopup({ open:true, location })
}

const handleSetAsPoint = (type, location) => {
  const updated = addedLocations.map((loc) => {
    const isSame = loc?.index === location?.index

  
      return {
      ...loc,
      starting_point:
        type === 'start'
          ? isSame // set only this as start
            ? true
            : false // unset all others
          : type === 'both'
          ? isSame // set both
            ? true
            : false
          : type === 'end' && isSame
          ? false // if setting as end, remove start on the same location
          : type === 'remove' && isSame
          ? false // remove start if this is the one
          : loc.starting_point, // otherwise leave untouched

      ending_point:
        type === 'end'
          ? isSame
            ? true
            : false
          : type === 'both'
          ? isSame
            ? true
            : false
          : type === 'start' && isSame
          ? false // if setting as start, remove end on same
          : type === 'remove' && isSame
          ? false
          : loc.ending_point,
    }
  })

  setAddedLocations(updated)
  setMarkerPopup({ open: false, location: null })

    clearTimeout(hoverTimeout.current);
    setSelectedLocation(null);
    setMousePosition(null);
}

  
  const handlePopoverOpen = (event, location) => {
    clearTimeout(popoverTimer.current);

    let updatedLocation = { ...location };
    if (location.service_id !== null) {
      updatedLocation.attachments = location?.attachments?.length
        ? location.attachments
        : location?.service_image
        ? [{ name: location.service_image }]
        : [];
    }
  
    popoverTimer.current = setTimeout(() => {
      setMousePosition({ x: event.clientX ?? event?.domEvent?.clientX, y: event.clientY ?? event?.domEvent?.clientY });
      setAnchorEl(event.target ?? event?.domEvent?.target);
      setSelectedLocation(updatedLocation);
      console.log("Popover Opened at:", event.clientX ?? event?.domEvent?.clientX, event.clientY ?? event?.domEvent?.clientY);
      console.log("Updated Location Data:", updatedLocation);
    }, 200);
  };
  
  const handlePopoverClose = () => {
    clearTimeout(popoverTimer.current);
    setAnchorEl(null);
    setSelectedLocation(null);
  };  

  const open = Boolean(anchorEl);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 2000, // Changes every 2 seconds
    beforeChange: (oldIndex, newIndex) => setCurrentImageIndex(newIndex), // Track current slide
    customPaging: (i) => (
      <div
        style={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          backgroundColor: i === currentImageIndex ? "#007BFF" : "#ccc", // Active dot color
          margin: "0px",
        }}
      />
    ),
    dotsClass: "slick-dots slick-thumb",
  };

console.log("addedLocations>>>",addedLocations)
  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true)
      try {
        const response = await axios.post(
          `${REST_API_END_POINT}route/get-all-products-for-wed-route`,
        )
        const productListData = response.data.results
        if (productListData) {
          setAllproducts(productListData)
        } else {
          setAllproducts([])
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        setAllproducts([])
      } finally {
        setLoading(false)
      }
    }
    fetchProducts()
  }, [])

  const generateRandomMarkers = (qty, center, color) => {
    const markers = []
    for (let i = 0; i < qty; i++) {
      const randomLat = center.lat + (Math.random() - 0.5) * 0.02
      const randomLng = center.lng + (Math.random() - 0.5) * 0.02
      markers.push({
        lat: randomLat,
        lng: randomLng,
        color,
      })
    }
    return markers
  }


const reverseGeocodeMapbox = async (lat, lng) => {
  const url =
    `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json` +
    `?types=address,postcode,place&access_token=${MAPBOX_ACCESS_TOKEN}`;

  console.log("Mapbox URL:", url);

  try {
    const res = await fetch(url);

    if (!res.ok) {
      const errorText = await res.text();
      console.error("Mapbox API error:", errorText);
      throw new Error("Mapbox geocode failed");
    }

    const { features = [] } = await res.json();
    const addressFeature = features.find(f => f.place_type.includes("address"));
    const best = addressFeature || features[0];

    if (!best) return {};

    const ctx = [...(best.context || [])];
    const byType = t =>
      ctx.find(c => c.id.startsWith(t + "."))?.text ?? null;

    const streetNumber = addressFeature?.address || null;
    const route = addressFeature?.text || null;

    return {
      wholeAddress: best.place_name,
      plusCode: null,
      streetNumber,
      route,
      address: (streetNumber || route)
        ? `${streetNumber ?? ""} ${route ?? ""}`.trim()
        : null,
      city: byType("place"),
      state: byType("region"),
      zip: byType("postcode"),
      country: byType("country"),
    };
  } catch (error) {
    console.error("Mapbox fetch failed:", error);
    throw error;
  }
};


//     const generateRandomColor = () => {
//   const randomHue = () => {
//     let hue;
//     do {
//       hue = Math.floor(Math.random() * 360);
//     } while (
//       (hue >= 0 && hue <= 20) ||      // exclude red
//       (hue >= 80 && hue <= 160) ||   // exclude green
//       (hue >= 340 && hue <= 360)     // also red wraparound
//     );
//     return hue;
//   };

//   const hue = randomHue();
//   const saturation = Math.floor(60 + Math.random() * 30); // 60–90%
//   const lightness = Math.floor(40 + Math.random() * 30);  // 40–70%

//   return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
// };


  // const handleMarkerDrag = async (event, index, location) => {
  //   const newLat = event.latLng.lat();
  //   const newLng = event.latLng.lng();
  //   console.log("locationData event---", event);
  
  //   const updatedLocations = [...addedLocations];
  //   updatedLocations[index] = {
  //     ...updatedLocations[index],
  //     lat: newLat,
  //     lng: newLng,
  //   };
  
  //   const geocoder = new google.maps.Geocoder();
  //   geocoder.geocode({ location: { lat: newLat, lng: newLng } }, async (results, status) => {
  //     if (status === "OK" && results[0]) {
  //       const components = results[0].address_components;
  //       const plusCode = components.find((c) => c.types.includes("plus_code"))?.long_name || null;
  //       const streetNumber = components.find((c) => c.types.includes("street_number"))?.long_name || "";
  //       const route = components.find((c) => c.types.includes("route"))?.long_name || "";
  //       const address = plusCode || (streetNumber || route ? `${streetNumber} ${route}`.trim() : null);
  //       const country = components.find((c) => c.types.includes("country"))?.long_name || null;
  //       const city = components.find((c) => c.types.includes("locality"))?.long_name || null;
  //       const state = components.find((c) => c.types.includes("administrative_area_level_1"))?.short_name || null;
  //       const zip = components.find((c) => c.types.includes("postal_code"))?.long_name || null;
  
  //       updatedLocations[index].address = address;
  //       updatedLocations[index].city = city;
  //       updatedLocations[index].state = state;
  //       updatedLocations[index].zip = zip;
  //       updatedLocations[index].country = country;
  //       updatedLocations[index].wholeAddress = results[0].formatted_address;
        
  //       // if(location?.type === 'product'){
  //       //   await handleUpdateProductsAddress({
  //       //     order_id: location?.order_id || location?.id,
  //       //     location_id: location?.id,
  //       //     address: address,
  //       //     city: city,
  //       //     state: state,
  //       //     zip: zip,
  //       //     lat:newLat,
  //       //     lng:newLng
  //       //   });
  //       // }
  //       // if(location?.type === 'service'){
  //       //   await handleUpdateServiceAddress({
  //       //     service_id: location?.service_id,
  //       //     location_id: location?.id,
  //       //     address: address,
  //       //     city: city,
  //       //     state: state,
  //       //     zip: zip,
  //       //     lat:newLat,
  //       //     lng:newLng
  //       //   });
  //       // }
  //       setAddedLocations(updatedLocations);
  //     }
  //   });
  // };
  
const generateRandomColor = () => {
  const hue = Math.floor(Math.random() * 360);                  // Hue: full spectrum
  const saturation = 40 + Math.floor(Math.random() * 60);       // Saturation: 40%–100%
  const lightness = 20 + Math.floor(Math.random() * 60);        // Lightness: 20%–80%

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};


const handleChangeProductColor = (productId,productIndex,data) => {

  const newColor = generateRandomColor(1);

  // 1. Update selectedProducts
  setSelectedProducts((prev) =>
    prev.map((product) =>
     ( product.id === productId) && (product.indexId ==productIndex) ? { ...product, color: newColor } : product
    )
  );

  // 2. Update addedLocations
  setAddedLocations((prev) =>
    prev.map((location) =>
     ( location.req_loc_id === data.location[0].req_loc_id)  ? { ...location, color: newColor } : location
    )
  );
};

const handleChangeRFPProductColor = (data) => {
  console.log('handleChangeRFPProductColor data:', data);

  const newColor = generateRandomColor(1);
  const targetReqLocId = data?.location?.[0]?.req_loc_id || data?.req_loc_id;

  if (!targetReqLocId) {
    console.warn('Missing req_loc_id in RFP product data');
    return;
  }

  // 1. Update selectedRfpProduct
  setSelectedRfpProduct((prev) =>
    prev.map((product) =>
      product?.location?.[0]?.req_loc_id === targetReqLocId
        ? { ...product, color: newColor }
        : product
    )
  );

  // 2. Update addedLocations
  setAddedLocations((prev) =>
    prev.map((location) =>
      location.req_loc_id === targetReqLocId
        ? { ...location, color: newColor }
        : location
    )
  );
};


const handleChangeServiceColor = (data) => {
  const newColor = generateRandomColor(1);
  const targetReqLocId = data?.req_loc_id 

  if (!targetReqLocId) {
    console.warn('Missing req_loc_id for service color update.');
    return;
  }

  // 1. Update additionalSelectedServices
  setAdditionalSelectedServices((prev) =>
    prev.map((service) =>
      service.req_loc_id === targetReqLocId
        ? { ...service, color: newColor }
        : service
    )
  );

  // 2. Update addedLocations (map markers)
  setAddedLocations((prev) =>
    prev.map((location) =>
      location.req_loc_id === targetReqLocId
        ? { ...location, color: newColor }
        : location
    )
  );
};

const handleChangeRFPServiceColor = (data) => {
  const newColor = generateRandomColor(1);
  const targetReqLocId = data?.req_loc_id 

  if (!targetReqLocId) {
    console.warn('Missing req_loc_id for service color update.');
    return;
  }

  // 1. Update additionalSelectedServices
  setSelectedRfpServices((prev) =>
    prev.map((service) =>
      service.req_loc_id === targetReqLocId
        ? { ...service, color: newColor }
        : service
    )
  );

  // 2. Update addedLocations (map markers)
  setAddedLocations((prev) =>
    prev.map((location) =>
      location.req_loc_id === targetReqLocId
        ? { ...location, color: newColor }
        : location
    )
  );
};



  const handleMarkerDrag = async (event, index, location) => {
  // if(hasRouteMovingPermission) return enqueueSnackbar('Access Denied You do not have sufficiant permission.', {variant: 'error',})
  // console.log('hasRouteMovingPermission', hasRouteMovingPermission)

  const newLat = event.lat;
  const newLng = event.lng;

  const geo = await reverseGeocodeMapbox(newLat, newLng);


  const updated = addedLocations.map(loc => {
    if (loc.index === location.index) {
      return {
        ...loc,
        lat: newLat,
        lng: newLng,
        address: geo?.wholeAddress || loc.address,
        city: geo?.city ?? loc.city,
        state: geo?.state ?? loc.state,
        zip: geo?.zip ?? loc.zip,
        country: geo?.country ?? loc.country,
        wholeAddress: geo?.wholeAddress ?? loc.wholeAddress,
      };
    }
    return loc;
  });

  setAddedLocations(updated);
};


  //   const handleMarkerDrag = async (event, index, location) => {
  //   const newLat = event.lat
  //   const newLng = event.lng
  //   console.log("locationData event index location---", event,index,location);
  
  //   console.log('addedLocationsaddedLocations', addedLocations)
  //   const updatedLocations = [...addedLocations];
  //   updatedLocations[index] = {
  //     ...updatedLocations[index],
  //     lat: newLat,
  //     lng: newLng,
  //   };
  //   console.log('addedLocationsaddedLocations 2', updatedLocations)

  
  //   const geo =  await reverseGeocodeMapbox(newLat, newLng);
  //   console.log('geocodegeocoder', geo)
    
  //     if (geo) {
       
  //       const streetNumber = geo?.streetNumber || "";
  //       const address =  geo?.wholeAddress
  //       const country =  geo?.country  || null;
  //       const city = geo?.city || null;
  //       const state = geo?.state || null;
  //       const zip = geo?.zip || null;
  
  //       updatedLocations[index].address = address;
  //       updatedLocations[index].city = city;
  //       updatedLocations[index].state = state;
  //       updatedLocations[index].zip = zip;
  //       updatedLocations[index].country = country;
  //       updatedLocations[index].wholeAddress = address;
  //       console.log('updatedLocations', updatedLocations)
        
      
  //       setAddedLocations(updatedLocations);
  //     }
    
  // };


  const handleUpdateProductsAddress = async (data) => {
    console.log('productsssssssss' , data)
    try {
      const response = await axios.post(`${REST_API_END_POINT}rfq/update-products-route`, data);
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: "success" });
      } else {
        enqueueSnackbar(response.data.message, { variant: "error" });
      }
    } catch (error) {
      console.log("Server error:", error);
      enqueueSnackbar("Server error", { variant: "error" });
    }
  };
  const handleUpdateServiceAddress = async (data) => {
    console.log("view dataaaa>",data)
    try {
      const response = await axios.post(`${REST_API_END_POINT}rfq/update-service-route`, data);
      if (response.data.status === 1) {
        console.log("address updated")
        enqueueSnackbar(response.data.message, { variant: "success" });
      } else {
        enqueueSnackbar(response.data.message, { variant: "error" });
      }
    } catch (error) {
      console.log("Server error:", error);
      enqueueSnackbar("Server error", { variant: "error" });
    }
  };



  const handleMarkerDelete = () => {
    // Create a new array without the deleted location
    const updatedLocations = addedLocations.filter(
      (_, i) => i !== deleteLocationIndex,
    )
    setDeleteLocationIndex(null)
    // Update state and recalculate the route
    setAddedLocations(updatedLocations)
    calculateRoutes(updatedLocations)
  }

  const handleFetchLocations = async () => {
    try {
      let productLocations = []
      let serviceLocations = []
      let rfpProductLocations = []
      let rfpServiceLocations = []
      if (requestProducts?.length > 0) {
        const routeData = locationDetails || null
        const productData = requestProducts || null
        console.log('viewroute---allproducts', allProducts)
        console.log('viewroute---routeData', routeData)
        console.log('viewroute---productData', productData)
        const colorMap = new Map(); 
        // let newProducts = productData
        // ? await Promise.all(
        //     productData.map(async (item) => ({
        //       ...item, 
        //       color: item?.color || generateRandomColor(2),
        //       quantity: item?.quantity || 0,
        //     }))
        //   )
        // : [];
       let newProducts = productData
       ? await Promise.all(
         productData.map(async (item) => {
           const key = `${item.id}-${item.indexId}`; // use both id and indexId
           console.log('keykeykeykey', key)
           let color;
           
           if (colorMap.has(key)) {
             color = colorMap.get(key);
            } else {
              color =item?.location[0].color || generateRandomColor(2); // assign new color
              colorMap.set(key, color);       // store it
            }
            
            return {
              ...item,
              color,
              quantity: item?.quantity || 0,
            };
          })
        )
        : [];
        console.log('newProducts', newProducts)
        
        
        setSelectedProducts(newProducts?.filter(Boolean)) 
        productLocations =
          routeData &&
          (await Promise.all(
            routeData?.map(async (item) => {
              console.log('newProducts item', item)
              // const product = newProducts?.find( (prod) => prod.id == item.product_id && prod.location[0].req_loc_id == item.req_loc_id)
              const product = newProducts?.find((prod) => {
                if (prod.id !== item.product_id) return false;
                return prod.location?.some((loc) => loc.req_loc_id == item.req_loc_id);
              });
              let lat = item.lat ? parseFloat(item.lat) : null
              let lng = item.lng ? parseFloat(item.lng) : null
              // console.log('location1>>>', product)
              let installationAddress = `${item?.address}, ${item?.city}, ${item?.state}, ${item?.zip}`
              if (isFromPs && (!lat || !lng)) {
                installationAddress = `${item?.address}, ${item?.city}, ${item?.state}, ${item?.zip}`
                try {
                  let latLong = await getLatandLongFromAddress(
                    installationAddress,
                  )
                  lat = latLong?.Latitude || lat
                  lng = latLong?.Longitude || lng
                  if(lat && lng){
                    await handleUpdateProductsAddress({
                      // order_id: product?.location[0]?.order_id,
                      // order_id: item?.order_id || item?.id,
                      location_id: item?.id,
                      lat:lat,
                      lng:lng,
                    });
                  }
                } catch (error) {
                  console.error('Error fetching lat/long:', error)
                }
              }
              console.log('allAttachments==',allAttachments)
              console.log('allAttachments locations==',item)
              return {
                lat,
                lng,
                is_dos: item?.is_dos || null,
                address: item.address || null, // Use geocoded address if available
                city: item.city || null,
                state: item.state || null,
                zip: item.zip || null,
                color: product ? product.color : 'black',
                productId: product ? product.id : null,
                order_id: item?.order_id || null,
                location_id: item?.id,
                type:'product',
                productName: product ? product.name : null,
                service_image: product?.service_image || null,
                country: item.country || 'USA',
                // attachments: allAttachments || product.attachments || [],
                attachments: allAttachments?.filter(att =>
                  att.location_ids?.split(',').includes(String(item.id))
                ) || [],
                quantity:product?.quantity || 0,
                wholeAddress: item.wholeAddress || installationAddress || null,
                starting_point: item?.starting_point || null,
                ending_point: item?.ending_point || null,
                req_loc_id:item?.req_loc_id || null,
              }
            }),
          ))
      }
     
      if (additionalSelectedServices?.length > 0) {
        // const updatedAdditionalServices = additionalSelectedServices.map(
        //   (item) => ({
        //     ...item,
        //     color: item.color ? item.color : generateRandomColor(3),
        //   }),
        // )

        const updatedAdditionalServices = additionalSelectedServices.map((item) => {
          
       
  // Only add color if it's missing
  if (item.color ==null && item.id) {
      

    return { ...item, color: generateRandomColor(3,item.color) };
  }
  return item; // return unchanged if color already exists
});
        if (
          JSON.stringify(updatedAdditionalServices) !==
          JSON.stringify(additionalSelectedServices)
        ) {
          setAdditionalSelectedServices(updatedAdditionalServices)
        }

        serviceLocations = await Promise.all(
          updatedAdditionalServices.map(async (item) => {
            let lat = item.lat ? parseFloat(item.lat) : null
            let lng = item.lng ? parseFloat(item.lng) : null
            let serviceAddress = `${item?.address}, ${item?.city}, ${item?.state}, ${item?.zip}`

            if (!lat || !lng) {
              serviceAddress = `${item?.address}, ${item?.city}, ${item?.state}, ${item?.zip}`
              try {
                let latLong = await getLatandLongFromAddress(serviceAddress)
                lat = latLong?.Latitude || lat
                lng = latLong?.Longitude || lng
                if(lat && lng){
                  await handleUpdateServiceAddress({
                    service_id: item?.id,
                    lat:lat,
                    lng:lng,
                    is_lat_lng:true
                  });
                }
              } catch (error) {
                console.error('Error fetching lat/long:', error)
              }
            }

            console.log('service_item', item)
            return {
              lat,
              lng,
              is_dos: (item?.is_dos === 1 || item?.service_type === 33) ? 1 : null,
              address: item.address || null,
              city: item.city || null,
              state: item.state || null,
              zip: item.zip || null,
              color: item.color,
              productId: item?.id || null,
              service_id: item?.id || null,
              type:'service',
              productName: item?.name || null,
              service_image: item?.service_image || null,
              country: item.country || 'USA',
              quantity:item?.quantity || 0,
              sales_order:item.request_name || '',
              wholeAddress: item.wholeAddress || serviceAddress || null,
              starting_point: item?.starting_point || null,
              ending_point: item?.ending_point || null,
              req_loc_id:item?.req_loc_id || null,
            }
          }),
        )
      }

      if (selectedRfpServices?.length > 0) {
        rfpServiceLocations = await Promise.all(
          selectedRfpServices.map(async (item) => {
            let lat = item.lat ? parseFloat(item.lat) : null
            let lng = item.lng ? parseFloat(item.lng) : null
            let serviceAddress = `${item?.address}, ${item?.city}, ${item?.state}, ${item?.zip}`
            console.log('service_item_rfp', item)
            return {
              lat,
              lng,
              is_dos: (item?.is_dos === 1 || item?.service_type === 33) ? 1 : null,
              address: item.address || null,
              city: item.city || null,
              state: item.state || null,
              zip: item.zip || null,
              color: item.color,
              productId: item?.id || null,
              service_id:item?.id || null,
              type:'service',
              productName: item?.name || null,
              service_image: item?.service_image || null,
              country: item.country || 'USA',
              quantity:item?.quantity || 0,
              sales_order:item.request_name || '',
              wholeAddress: item.wholeAddress || serviceAddress || null,
              starting_point: item?.starting_point || null,
              ending_point: item?.ending_point || null,
              req_loc_id:item?.req_loc_id || null,
            }
          }),
        )
      }
      if (selectedRfpProduct?.length > 0) {
        rfpProductLocations = await Promise.all(
          selectedRfpProduct.map(async (item) => {
            console.log('selectedRfpProductitem', item)
            let lat = item.lat ? parseFloat(item.lat) : null
            let lng = item.lng ? parseFloat(item.lng) : null
            let serviceAddress = `${item?.address}, ${item?.city}, ${item?.state}, ${item?.zip}`

            return {
              ...item,
              lat,
              lng,
              is_dos: item?.is_dos || null,
              address: item.address || null,
              city: item.city || null,
              state: item.state || null,
              zip: item.zip || null,
              color: item.color,
              productId: item?.product_id || null,
              type:'product',
              order_id:item?.customer_order_product_id,
              location_id:item?.request_location_id, // item?.id,
              attachments:item.attachments || [],
              productName: item?.product_name || null,
              service_image: item?.service_image || null,
              country: item.country || 'USA',
              quantity:item?.quantity || 0,
              wholeAddress: item.wholeAddress || serviceAddress || null,
              starting_point: item?.starting_point || null,
              ending_point: item?.ending_point || null,
              req_loc_id:item?.req_loc_id || null,
            }
          }),
        )
      }
      if (
        productLocations?.length > 0 ||
        serviceLocations?.length > 0 ||
        rfpProductLocations?.length > 0 ||
        rfpServiceLocations?.length > 0
      ) {
        const combinedArray = [...productLocations,...serviceLocations,...rfpProductLocations,...rfpServiceLocations]
        console.log('processedLocations--',combinedArray);
        
        const filteredLocations = combinedArray?.filter(item => 
          item?.is_dos === null || item?.is_dos === 0
        )?.map((item, index) => ({
          ...item, 
          index: index + 1
          }));        
        setAddedLocations(filteredLocations);
        calculateRoutes(filteredLocations)
      } else {
        setAddedLocations([])
        setSelectedProducts([])
      }
    } catch (error) {
      console.error('Error fetching locations:', error)
      setAddedLocations([])
      setSelectedProducts([])
    } finally {
      setIsLoading(false)
    }
  }

  console.log('newProducts=2====', selectedProducts)
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (
        allProducts?.length > 0 &&
        selectedRoute &&
        (requestProducts?.length > 0 || 
         locationDetails?.length > 0 || 
         additionalSelectedServices?.length > 0 || 
         selectedRfpServices?.length > 0 || 
         selectedRfpProduct?.length > 0)
      ) {
        setDebouncedFetch(true);
      }
    }, 1000);
  
    return () => clearTimeout(timeout);
  }, [selectedRoute, allProducts, locationDetails,render ]); //, additionalSelectedServices, selectedRfpServices, selectedRfpProduct]);
  
  useEffect(() => {
    if (debouncedFetch) {
      handleFetchLocations();
      setDebouncedFetch(false); // Reset after API call
    }
  }, [debouncedFetch]);



  // const handleSaveLocations = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${REST_API_END_POINT}route/save-locations`,
  //       { selectedRoute, addedLocations, selectedProducts, userId },
  //     )
  //     if (response.data.status === 1) {
  //       enqueueSnackbar('Locations saved successfully!', { variant: 'success' })
  //       navigate(PATH_DASHBOARD.transportation.routes, { state: { ts: true } })
  //     } else {
  //       enqueueSnackbar('Failed to save locations.', { variant: 'error' })
  //     }
  //   } catch (error) {
  //     console.error('Error saving locations:', error)
  //     enqueueSnackbar('An error occurred while saving locations.', {
  //       variant: 'error',
  //     })
  //   }
  // }

  const handleSaveLocations = async () => {
  try {
     setIsSaving(true);
    const productUpdates = addedLocations.filter(loc => loc.type === 'product');
    const serviceUpdates = addedLocations.filter(loc => loc.type === 'service');

    // Update all product locations
    for (const product of productUpdates) {
      console.log('productUpdates', product)
      const payload = {
        order_id: product?.order_id || product?.id,
        location_id: product?.location_id || product?.id,
        address: product?.address,
        city: product?.city,
        state: product?.state,
        zip: product?.zip,
        lat: product?.lat,
        lng: product?.lng,
        starting_point: product?.starting_point || false,
        ending_point: product?.ending_point || false,
        color: product?.color ,
      };

      try {
        const response = await axios.post(`${REST_API_END_POINT}rfq/update-products-route`, payload);
        if (response.data.status !== 1) {
          enqueueSnackbar(`Product update failed: ${response.data.message}`, { variant: "error" });
        }
      } catch (err) {
        enqueueSnackbar(`Product update error: ${err.message}`, { variant: "error" });
      }
    }

    // Update all service locations
    for (const service of serviceUpdates) {
      const payload = {
        service_id: service?.service_id,
        location_id: service?.location_id || service?.id,
        address: service?.address,
        city: service?.city,
        state: service?.state,
        zip: service?.zip,
        lat: service?.lat,
        lng: service?.lng,
        starting_point: service?.starting_point || false,
        ending_point: service?.ending_point || false,
        color: service?.color ,
      };

      try {
        const response = await axios.post(`${REST_API_END_POINT}rfq/update-service-route`, payload);
        if (response.data.status !== 1) {
          enqueueSnackbar(`Service update failed: ${response.data.message}`, { variant: "error" });
        }
      } catch (err) {
        enqueueSnackbar(`Service update error: ${err.message}`, { variant: "error" });
      }
    }

    enqueueSnackbar('All locations updated successfully.', { variant: 'success' });
  } catch (error) {
    console.error('Error updating locations:', error);
    enqueueSnackbar('An error occurred while updating locations.', {
      variant: 'error',
    });
  } finally {
    setIsSaving(false); // ✅ stop loading
  }
};



 



  useEffect(() => {
    const pubnub = new PubNub({
      publishKey: PUBNUB_PUBLISH_KEY,
      subscribeKey: PUBNUB_SUBSCRIBE_KEY,
      secretKey: PUBNUB_SECRET_KEY,
    })

    pubnub.addListener({
      message: (messageEvent) => {
        const {
          driverId,
          latitude,
          longitude,
          speed,
          customer_name,
          address,
          city,
          state,
          zipcode,
          driver_name,
        } = messageEvent.message
        setSelectedDriverId(driverId)
        setMarkers((prevMarkers) => {
          const existingMarker = prevMarkers.find(
            (marker) => marker.driverId === driverId,
          )
          if (existingMarker) {
            return prevMarkers.map((marker) =>
              marker.driverId === driverId
                ? {
                    ...marker,
                    lat: Number(latitude),
                    lng: Number(longitude),
                    speed,
                  }
                : marker,
            )
          } else {
            return [
              ...prevMarkers,
              {
                driverId,
                lat: latitude,
                lng: longitude,
                speed,
                customer_name,
                address,
                city,
                state,
                zipcode,
                driver_name,
              },
            ]
          }
        })
      },
    })

    pubnub.subscribe({ channels: ['driver_location'] })

    return () => {
      pubnub.unsubscribeAll()
    }
  }, [])

  useEffect(async () => {
    try {
      if (selectedDriverId) {
        const response = await axios.post(
          `${REST_API_END_POINT}driver/get-driver-by-userId`,
          { id: selectedDriverId },
        )
        if (response.data.status === 1) {
          setOriginalDriverId(response.data.result[0].id)
          setSelectedOriginalDriverId(response.data.result[0].id)
        }
      }
    } catch (error) {
      console.log('error', error)
    }
  }, [selectedDriverId])


  const initializeLocations = async (value) => {
    console.log('location data 1', value)

    if (selectedData.assigned && value?.appointments) {
      console.log('location data 2')

      const installations = await fetchInstallationLocations(value.appointments)
      setLocations(installations) // Initialize locations state
      calculateRoute(installations) // Calculate route based on initial locations
      console.log('location data 3', installations)
    }
  }


  useEffect(() => {
  const script = document.createElement('script')
script.src = 'https://api.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.js'
script.async = true
script.onload = () => setApiLoaded(true)
document.body.appendChild(script)

const link = document.createElement('link')
link.href = 'https://api.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.css'
link.rel = 'stylesheet'
document.head.appendChild(link)
}, [])

  useEffect(() => {
    if (apiLoaded && (markers.length > 0 || locations.length > 0)) {
      console.log(
        'apiLoadedapiLoaded',
        apiLoaded,
        markers.length,
        locations.length,
      )
      calculateRoute(locations)
    }
  }, [markers, locations, selectedRoute, selectedSalesOrder, apiLoaded])


//   const calculateRoute = (locations) => {


//     const waypoints = [
//       { location: home, stopover: true },
//       ...locations.map((location) => ({
//         location: { lat: Number(location?.lat), lng: Number(location?.lng) },
//         stopover: true,
//       })),
//       { location: home, stopover: true },
//     ]

//     const origin = waypoints[0]?.location
//     const destination = waypoints[waypoints.length - 1]?.location

//     // const waypoints = locations.slice(1, -1).map((location) => ({
//     //   location: { lat: location.lat, lng: location.lng },
//     //   stopover: true,
//     // }));

//     const directionsService = new window.google.maps.DirectionsService()
//     directionsService.route(
//       {
//         origin,
//         destination,
//         waypoints,
//         travelMode: window.google.maps.TravelMode.DRIVING,
//       },
//       (result, status) => {
//         if (status === window.google.maps.DirectionsStatus.OK) {
//           setDirections(result) // Set the directions state
//           console.log('Directions result:', result)
//         } else {
//           console.error(`Directions request failed: ${status}`)
//           setDirections(null)
//         }
//       },
//     )
//   }


//   const calculateRoutes = (locations) => {
//   console.log('📍 calculateRoutes--locations--', locations);

//   if (!locations || locations.length === 0) {
//     console.error('❌ No locations provided. Cannot calculate route.');
//     setDirections([]);
//     return;
//   }

//   if (!home || !home.lat || !home.lng) {
//     console.error('❌ Home location is not defined properly:', home);
//     setDirections([]);
//     return;
//   }

//   const isTrue = (val) => val === true || val === 1 || val === 'true';

//   const startingPoint = locations.find((loc) => isTrue(loc?.starting_point)) || home;
//   const endingPoint = locations.find((loc) => isTrue(loc?.ending_point)) || home;

//   const intermediateLocations = locations
//     .filter((loc) => !isTrue(loc?.starting_point) && !isTrue(loc?.ending_point));

//   // Use tspSolver to reorder based on proximity from startingPoint
//   const tspPath = tspSolver(intermediateLocations, startingPoint);
//   const orderedLocations = tspPath || intermediateLocations;

//   // Convert into Google Maps waypoint format
//   const intermediateWaypoints = orderedLocations.map((location, idx) => {
//     const lat = Number(location.lat);
//     const lng = Number(location.lng);

//     if (isNaN(lat) || isNaN(lng)) {
//       console.error(`❌ Invalid lat/lng at index ${idx}:`, location);
//       return null;
//     }

//     return {
//       location: { lat, lng },
//       stopover: true,
//     };
//   }).filter(Boolean);


//   const newOrderData = [
//   ...(startingPoint?.index ? [{ ...startingPoint, type: 'STARTING_POINT' }] : []),
//   ...orderedLocations.map((loc) => ({
//     ...loc,
//     type: 'WAYPOINT',
//   })),
//   ...(
//     endingPoint?.index &&
//     (!startingPoint?.index || startingPoint.index !== endingPoint.index)
//       ? [{ ...endingPoint, type: 'ENDING_POINT' }]
//       : []
//   ),
// ];

//   setMapOrderData(newOrderData);

//   const splitIntoChunks = (array, chunkSize) => {
//     const chunks = [];
//     for (let i = 0; i < array.length; i += chunkSize) {
//       chunks.push(array.slice(i, i + chunkSize));
//     }
//     return chunks;
//   };

//   const waypointChunks = splitIntoChunks(intermediateWaypoints, 25);
//   const directionsService = new window.google.maps.DirectionsService();
//   const routeResults = [];

//   const calculateChunkRoute = (chunk) => {
//     return new Promise((resolve, reject) => {
//       const origin = {
//         lat: Number(startingPoint.lat),
//         lng: Number(startingPoint.lng),
//       };
//       const destination = {
//         lat: Number(endingPoint.lat),
//         lng: Number(endingPoint.lng),
//       };

//       if (!origin.lat || !origin.lng || !destination.lat || !destination.lng) {
//         console.error('❌ Invalid origin or destination coordinates');
//         reject('Invalid coordinates');
//         return;
//       }

//       directionsService.route(
//         {
//           origin,
//           destination,
//           waypoints: chunk,
//           travelMode: window.google.maps.TravelMode.DRIVING,
//         },
//         (result, status) => {
//           if (status === 'OK' && result?.routes?.[0]?.legs?.length > 0) {
//             resolve(result);
//           } else {
//             console.error(`❌ Directions request failed: ${status}`);
//             reject(`Route chunk failed: ${status}`);
//           }
//         }
//       );
//     });
//   };

//   const calculateAllRoutes = async () => {
//     try {
//       if (intermediateWaypoints.length === 0) {
//         const origin = {
//           lat: Number(startingPoint.lat),
//           lng: Number(startingPoint.lng),
//         };
//         const destination = {
//           lat: Number(endingPoint.lat),
//           lng: Number(endingPoint.lng),
//         };

//         directionsService.route(
//           {
//             origin,
//             destination,
//             travelMode: window.google.maps.TravelMode.DRIVING,
//           },
//           (result, status) => {
//             if (status === 'OK') {
//               setDirections([result]);
//             } else {
//               console.error(`❌ Directions (simple) failed: ${status}`);
//               setDirections([]);
//             }
//           }
//         );
//         return;
//       }

//       for (let i = 0; i < waypointChunks.length; i++) {
//         const chunk = waypointChunks[i];
//         const route = await calculateChunkRoute(chunk);
//         routeResults.push(route);
//       }

//       setDirections([...routeResults]);
//     } catch (error) {
//       console.error('❌ Error calculating routes:', error);
//       setDirections([]);
//     }
//   };

//   calculateAllRoutes();
// };




// SIMPLE A → B → … → A
const calculateRoute = async (locs) => {
  try {
    if (!apiLoaded) return console.warn('Mapbox API not loaded yet.');
  if (!home) return console.warn('Home location not ready.');
  if (!Array.isArray(locs) || locs.length === 0) return console.warn('No locations to route.');

    const pts = [
      { lat: home.lat, lng: home.lng },
      ...locs.map((l) => ({ lat: +l.lat, lng: +l.lng })),
      { lat: home.lat, lng: home.lng },
    ]

    const route = await mapboxDirections(pts)       // helper
    setDirections(route.geometry)                   // GeoJSON LineString
  } catch (err) {
    console.error('[Mapbox] calculateRoute:', err)
    setDirections(null)
  }
}



const isTrue = v => v === true || v === 1 || v === 'true';
const isFiniteNumber = v => typeof v === 'number' && isFinite(v)    

const chunkArray = (arr, max = 25) => {
  const step   = max - 1          // leave space for the overlap
  const chunks = []

  for (let i = 0; i < arr.length; i += step) {
    // slice up to max items
    const chunk = arr.slice(i, i + max)

    // add the overlap (except for the first chunk)
    if (i !== 0) {
      chunk.unshift(arr[i - 1])   // prepend previous point
      if (chunk.length > max) {
        chunk.pop()               // trim to stay ≤ max
      }
    }

    chunks.push(chunk)
  }
  return chunks
}

const calculateRoutes = async (initialLocs  = []) => {
  try {
       const locs = initialLocs?.map((l, i) => ({ ...l, index: i + 1 }));
       
    

setAddedLocations(locs);

    if (!apiLoaded || !home || !Array.isArray(locs) || !locs.length) {
      console.log('calculateRoutes 1',apiLoaded)
      setMapOrderData([])
      setDirections(null)
      return
    }
      console.log('calculateRoutes 2',apiLoaded,locs)


    const startTag = locs.find(l => isTrue(l.starting_point))
    const endTag = locs.find(l => isTrue(l.ending_point))
    const startPt = startTag ?? home
    const endPt = endTag ?? home
    const mids = locs.filter(l => l !== startTag && l !== endTag)
    const ordered = tspSolver(mids, startPt) || mids

    const rawPts = [
      { lng: +startPt.lng, lat: +startPt.lat },
      ...ordered.map(l => ({ lng: +l.lng, lat: +l.lat })),
      { lng: +endPt.lng, lat: +endPt.lat }
    ]

    const pts = rawPts
      .filter(p => isFiniteNumber(p.lat) && isFiniteNumber(p.lng))
      .filter(p => !(p.lat === 0 && p.lng === 0))

    if (pts.length < 2) throw new Error('Not enough valid coordinates')

   let line

    if (pts.length <= 25) {
      const route = await mapboxDirections(pts)
      line = route.geometry
    } else {
      /*  NEW: use the fixed chunker  */
      const chunks   = chunkArray(pts, 25)
      const fullLine = { type: 'LineString', coordinates: [] }

      for (let i = 0; i < chunks.length; i++) {
        try {
          const partial = await mapboxDirections(chunks[i])
          fullLine.coordinates.push(...partial.geometry.coordinates)
        } catch (e) {
          console.warn(`❌  Chunk #${i + 1} failed (size ${chunks[i].length}).`, e.message)
        }
      }

      if (!fullLine.coordinates.length)
        throw new Error('All route chunks failed')
      line = fullLine
    }

    const list = [
      ...(startPt?.index ? [{ ...startPt, type: 'STARTING_POINT' }] : []),
      ...ordered.map(l => ({ ...l, type: 'WAYPOINT' })),
      ...(endPt?.index && (!startPt?.index || startPt.index !== endPt.index)
        ? [{ ...endPt, type: 'ENDING_POINT' }]
        : [])
    ]

    setMapOrderData(list)
    setDirections(line)
  } catch (err) {
    console.error('[Mapbox] calculateRoutes:', err.message)
    setMapOrderData([])
    setDirections(null)
  }
}

  const handleMarkerDragEnd = async (event, index, location) => {
    const newLat = event.latLng.lat()
    const newLng = event.latLng.lng()
    console.log('locationlocationlocation', location)

    // Update the location in the state
    setLocations((prevLocations) => {
      const updatedLocations = [...prevLocations]
      updatedLocations[index] = {
        ...updatedLocations[index],
        lat: Number(newLat),
        lng: Number(newLng),
      }
      calculateRoute(updatedLocations)
      return updatedLocations
    })

    console.log(
      `Marker ${index} moved to: Latitude: ${newLat}, Longitude: ${newLng}`,
    )

    // Recalculate the route with updated locations
    //update lat long on installation table
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}installation/update-lat-lng`,
        {
          markerId: location.id,
          latitude: Number(newLat), // Ensure latitude is sent as a number
          longitude: Number(newLng), // Ensure longitude is sent as a number
        },
      )

      if (response.data.status === 1) {
        console.log('Marker updated successfully in DB:', response.data)
      } else {
        console.error('Failed to update marker in DB:', response.data)
      }
    } catch (error) {
      console.error('Error updating marker in DB:', error)
    }
  }

 



  return (
    <Grid item xs={12}>
      <Stack direction="column" spacing={2} sx={{ mb: 2 }}>
        <HeaderBreadcrumbs
          sx={{ mt: 2 }}
          heading={`Route Details${selectedData?.name ? ` - ${selectedData?.name}` : ''}`}
          action={
            <Stack direction="row" spacing={2}>
              <Button
                sx={{ mt: 2 }}
                variant="outlined"
                startIcon={
                  <Stack>
                    <KeyboardBackspaceOutlined />
                  </Stack>
                }
                onClick={() =>
                  navigate(PATH_DASHBOARD.transportation.routes, {
                    state: { ts: false },
                  })
                }
              >
                Back to Routes
              </Button>
            </Stack>
          }
        />
      </Stack>

      <Card sx={{ mb: 2 }} variant='outlined'>
        {!details ? (
          <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ 
                    p: 1, 
                    borderRadius: '50%', 
                    bgcolor: 'primary.main', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)'
                  }}>
                    <WorkOutline sx={{ fontSize: 20 }} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Job Name
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 600, color: 'text.primary' }}>
                      {details?.name || 'N/A'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ 
                    p: 1, 
                    borderRadius: '50%', 
                    bgcolor: 'success.main', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)'
                  }}>
                    <PersonOutline sx={{ fontSize: 20 }} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Client
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 600, color: 'text.primary' }}>
                      {details?.customer_name || 'N/A'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ 
                    p: 1, 
                    borderRadius: '50%', 
                    bgcolor: 'warning.main', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    boxShadow: '0 2px 8px rgba(237, 108, 2, 0.3)'
                  }}>
                    <Business sx={{ fontSize: 20 }} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Project
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 600, color: 'text.primary' }}>
                      {details?.community_name || 'N/A'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ 
                    p: 1, 
                    borderRadius: '50%', 
                    bgcolor: '#2ca01c', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    boxShadow: '0 2px 8px rgba(76, 175, 80, 0.3)'
                  }}>
                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover" }} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      QB#
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 600, color: 'text.primary' }}>
                      {details?.doc_number || 'N/A'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </Card>
     
      {isLoading ? (
        <CircularProgress color="inherit" size={20} />
      ) : (
        <>
        
          {selectedProducts?.length > 0 ? (
            <Accordion sx={{ my: 3 }}>
              <AccordionSummary
                sx={{ color: '#919EAB' }}
                expandIcon={
                  <Icon icon={arrowIosDownwardFill} width={20} height={20} />
                }
              >
                Selected Products
              </AccordionSummary>
              <AccordionDetails>
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 500 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Sl No.</TableCell>
                          <TableCell>Product Name</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedProducts?.map((data, index) => (
                          <TableRow key={index}>
                            <TableCell>#{index + 1}</TableCell>
                            <TableCell>
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                              >
                                <div
                                  style={{
                                    width: '18px',
                                    height: '18px',
                                    borderRadius: '50%',
                                    backgroundColor: data.color || 'black',
                                  }}
                                ></div>
                                <span>{data.name}</span>
                              </Stack>
                            </TableCell>
                            <TableCell>
                              <TextField
                                label="Quantity"
                                type="number"
                                // value={data.quantity || 0}
                                value={data?.locationQuantity || 1}
                                disabled
                              />
                            </TableCell>
                             <TableCell>
                             <Tooltip title="Change Color">
                                 <IconButton onClick={() => handleChangeProductColor(data.id,data.indexId,data)}>
                                 <Refresh />
                               </IconButton>
                              </Tooltip>
                          </TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
              </AccordionDetails>
            </Accordion>
          ) : (
            ''
          )}
          {additionalSelectedServices?.filter(item=>!item?.is_dos && item?.service_type != 33)?.length > 0 ? (
            <Accordion sx={{ my: 3 }}>
              <AccordionSummary
                sx={{ color: '#919EAB' }}
                expandIcon={
                  <Icon icon={arrowIosDownwardFill} width={20} height={20} />
                }
              >
                Selected Additional Services
              </AccordionSummary>
              <AccordionDetails>
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 500 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Sl No.</TableCell>
                          <TableCell>Additional Service Name</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {additionalSelectedServices?.filter(item=>!item?.is_dos && item?.service_type != 33)?.map((data, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell>#{index + 1}</TableCell>
                              {/* <TableCell>{data.name}</TableCell> */}
                              <TableCell>
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  alignItems="center"
                                >
                                  <div
                                    style={{
                                      width: '18px',
                                      height: '18px',
                                      borderRadius: '50%',
                                      backgroundColor: data.color || 'black',
                                    }}
                                  ></div>
                                  {/* <span>{data.name}{data?.is_dos == 1 ? ' (From Design)' : ''}</span> */}
                                  <span>{data.name}</span>
                                </Stack>
                              </TableCell>
                              <TableCell>
                                <TextField
                                  label="Quantity"
                                  type="number"
                                  value={data.quantity > 0 ? data?.quantity : 1}
                                  disabled
                                  onChange={(event) => {
                                    const qty = Number(event.target.value)
                                  }}
                                />
                              </TableCell>
                               <TableCell>
                             <Tooltip title="Change Color">
                                 <IconButton onClick={() => handleChangeServiceColor(data)}>
                                 <Refresh />
                               </IconButton>
                              </Tooltip>
                          </TableCell>

                              <TableCell></TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
              </AccordionDetails>
            </Accordion>
          ) : (
            ''
          )}
          {selectedRfpProduct?.length > 0 ? (
            <Accordion sx={{ my: 3 }}>
              <AccordionSummary
                sx={{ color: '#919EAB' }}
                expandIcon={
                  <Icon icon={arrowIosDownwardFill} width={20} height={20} />
                }
              >
                Selected Proposal Products
              </AccordionSummary>
              <AccordionDetails>
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 500 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Sl No.</TableCell>
                          <TableCell>Proposal Products Name</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedRfpProduct?.map((data, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell>#{index + 1}</TableCell>
                              {/* <TableCell>{data.name}</TableCell> */}
                              <TableCell>
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  alignItems="center"
                                >
                                  <div
                                    style={{
                                      width: '18px',
                                      height: '18px',
                                      borderRadius: '50%',
                                      backgroundColor: data.color || 'black',
                                    }}
                                  ></div>
                                  <span>{data.product_name}</span>
                                </Stack>
                              </TableCell>
                              <TableCell>
                                <TextField
                                  label="Quantity"
                                  type="number"
                                  value={data?.location_quantity > 0 ? data?.location_quantity : 1}
                                  disabled
                                  onChange={(event) => {
                                    const qty = Number(event.target.value)
                                  }}
                                />
                              </TableCell>

                               <TableCell>
                             <Tooltip title="Change Color">
                                 <IconButton onClick={() => handleChangeRFPProductColor(data)}>
                                 <Refresh />
                               </IconButton>
                              </Tooltip>
                          </TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
              </AccordionDetails>
            </Accordion>
          ) : (
            ''
          )}
          {selectedRfpServices?.filter(item=>!item?.is_dos && item?.service_type != 33)?.length > 0 ? (
            <Accordion sx={{ my: 3 }}>
              <AccordionSummary
                sx={{ color: '#919EAB' }}
                expandIcon={
                  <Icon icon={arrowIosDownwardFill} width={20} height={20} />
                }
              >
                Selected Proposal Services
              </AccordionSummary>
              <AccordionDetails>
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 500 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Sl No.</TableCell>
                          <TableCell>Proposal Service Name</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedRfpServices?.filter(item=>!item?.is_dos && item?.service_type != 33)?.map((data, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell>#{index + 1}</TableCell>
                              {/* <TableCell>{data.name}</TableCell> */}
                              <TableCell>
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  alignItems="center"
                                >
                                  <div
                                    style={{
                                      width: '18px',
                                      height: '18px',
                                      borderRadius: '50%',
                                      backgroundColor: data.color || 'black',
                                    }}
                                  ></div>
                                  <span>{data.name}</span>
                                </Stack>
                              </TableCell>
                              <TableCell>
                                <TextField
                                  label="Quantity"
                                  type="number"
                                  value={data.quantity > 0 ? data?.quantity : 1}
                                  disabled
                                  onChange={(event) => {
                                    const qty = Number(event.target.value)
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                             <Tooltip title="Change Color">
                                 <IconButton onClick={() => handleChangeRFPServiceColor(data)}>
                                 <Refresh />
                               </IconButton>
                              </Tooltip>
                              </TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
              </AccordionDetails>
            </Accordion>
          ) : (
            ''
          )}
          {apiLoaded && home && locations && (
                      <MapBoxComponent
                        markers={addedLocations?.map((location) => ({
                          latitude: location.lat,
                          longitude: location.lng,
                          address: `${location.index}. ${location?.wholeAddress || ''}`,
                          raw: location,
                          index:location.index,
                          color:location.color,
                          starting_point:location?.starting_point,
                          ending_point:location?.ending_point,
                        }))}
                          // onMarkerHover={handleMarkerHover}  
                           onMarkerClick={handleMarkerClick}  
                           home={home}  
                           directions={directions}
                           onMarkerDragEnd={(e, index, marker) => handleMarkerDrag(e, index, marker)}
                           onSetPoint={handleSetAsPoint}
                           hasRouteMovingPermission={hasRouteMovingPermission}
                           details={details}
                           sliderSettings={sliderSettings}
                      />
          
                    )}
          {/* <Popover
            open={Boolean(selectedLocation) }
            anchorReference="anchorPosition"
          anchorPosition={
        mousePosition
      ? { top: mousePosition.y, left: mousePosition.x }
      : { top: 0, left: 0 } 
  }
           
             onClose={() => {
    clearTimeout(hoverTimeout.current);
    setSelectedLocation(null);
    setMousePosition(null);
  }}
            sx={{ pointerEvents: 'none' }} 
             PaperProps={{
    sx: {
      pointerEvents: 'auto', 
   
    },
  }}
          >
                    <Box
                   onMouseLeave={() => {
                hoverTimeout.current = setTimeout(() => {
                  setSelectedLocation(null);
                  setMousePosition(null);
                }, 150);
              }}
               >
            {selectedLocation && (
                           <Box sx={{ width: 250, p: 2, position: 'relative' }}
            
                >
                  
                <IconButton
              onClick={(e) => {
                e.stopPropagation(); 
                clearTimeout(hoverTimeout.current);
                setSelectedLocation(null);
                setMousePosition(null);
              }}
              sx={{ position: 'absolute', top: 4, right: 4, zIndex: 1 }}
              size="small"
            >
              <Close fontSize="small" />
            </IconButton>
             
                <Slider {...sliderSettings}>
                  {selectedLocation?.attachments?.map((attachment, index) => (
                    <Box key={index} component="img" src={attachment?.name} alt="Design"
                        sx={{ width: "100%", height: 120, objectFit: "cover" }} />
                  ))}
                </Slider>

                
                <Typography variant="h6">{selectedLocation?.productName || ""}</Typography>
                <Typography variant="body2">📍 {selectedLocation?.wholeAddress || "Location"}</Typography>
                <Typography variant="body2">📦 {selectedLocation?.quantity ? `Quantity: ${selectedLocation?.quantity}` : ""}</Typography>

                {!selectedLocation?.service_image && selectedLocation?.attachments?.[currentImageIndex] && (
                  <>
                    <Typography variant="body2">{selectedLocation?.attachments?.[currentImageIndex]?.approved_by_name ? `✅ Approved By: ${selectedLocation?.attachments?.[currentImageIndex]?.approved_by_name}` : ""}</Typography>
                    <Typography variant="body2">
                      {selectedLocation?.attachments?.[currentImageIndex]?.timestamp
                        ? `📅 Approved On: ${moment.unix(selectedLocation.attachments[currentImageIndex].timestamp).format("MM-DD-YYYY")}`
                        : ""}
                    </Typography>
                  </>
                )}
              </Box>
            )}

                    <Box sx={{ maxWidth: 200 }}>
                  <Typography sx={{ mb: 1, fontWeight: 600,ml:2 }}>
                    Choose an option:
                  </Typography>
            
                  <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    onClick={() => handleSetAsPoint('start', markerPopup.location)}
                    sx={{ mb: 0.5 ,ml:2}}
                  >
                    Set as Start
                  </Button>
            
                  <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    onClick={() => handleSetAsPoint('end', markerPopup.location)}
                    sx={{ mb: 0.5 ,ml:2}}
                  >
                    Set as End
                  </Button>
            
                  <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    onClick={() => handleSetAsPoint('both', markerPopup.location)}
                    sx={{ mb: 0.5 ,ml:2}}
                  >
                    Set as Both
                  </Button>
            
                  <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    color="secondary"
                    onClick={() => handleSetAsPoint('remove', markerPopup.location)}
                     sx={{ mb: 0.5 ,ml:2}}
                  >
                    Remove Start/End
                  </Button>
                    </Box>

            </Box>
          </Popover>  */}
         
        
          {(mapOrderData && mapOrderData?.length > 0 ) || (addedLocations && addedLocations.length >0)? (
            <Stack flexDirection={'row'} justifyContent={'space-between'}>
              <Box sx={{ mt: 2 }}>
                <>
                  <Typography variant="h6">Added Locations</Typography>
                  {mapOrderData?.filter(item=>item?.address != null)?.map((location, index) => (
                    <Box key={index} sx={{ mt: 1 }}>
                      {console.log('location>>>', location)}
                      <Typography variant="body2">
                        {location.index}. {location?.wholeAddress} (
                        {location?.lat?.toFixed(6)}, {location?.lng?.toFixed(6)}
                        ) - <span style={{color:'yellow'}}>{`${location?.productName} (${location?.location_id || location?.order_id || location?.service_id || location?.id || ''})`}</span>
                                                {' '}

  {location?.starting_point && location?.ending_point ? (
    <span style={{ color: 'green' }}>
      (starting <span style={{ color: 'red' }}>and ending point</span>)
    </span>
  ) : location.starting_point ? (
    <span style={{ color: 'green' }}>(starting point)</span>
  ) : location.ending_point ? (
    <span style={{ color: 'red' }}>(ending point)</span>
  ) : null}

                      </Typography>
                    </Box>
                  ))}
                </>
              </Box>
              <Box
                sx={{ mt: 2, gap: 2, display: 'flex', flexDirection: 'row' }}
              >
                {/* <Button
              variant="contained"
              sx={{ mt: 2, alignSelf: 'flex-start', }}
            
              onClick={handleSaveLocations}
            >
             Save Location
            </Button> */}
            <LoadingButton
  variant="contained"
  sx={{ mt: 2, alignSelf: 'flex-start' }}
  loading={isSaving}
  disabled={isSaving}
  onClick={handleSaveLocations}
>
  Save Location
</LoadingButton>

                <Button
                  variant="outlined"
                  sx={{
                    mt: 2,
                    alignSelf: 'flex-start', // Align this button to the right
                  }}
                  disabled={addedLocations?.length > 0 ? false : true}
                  onClick={() => {
                    // Conditional check if needed for the route calculation
                    // if(addedLocations.length > 23) {
                    calculateRoutes(addedLocations)
                    // } else {
                    //   calculateRoute(addedLocations);
                    // }
                  }}
                >
                  Generate Route
                </Button>
              </Box>
            </Stack>
          ) : (
            ''
          )}
          <ConfirmationPopup
            open={deleteLocationIndex ? true : false}
            handleClick={handleMarkerDelete}
            message={'You want to delete this location?'}
            handleClose={() => setDeleteLocationIndex(null)}
          />
        </>
      )}
    </Grid>
  )
}

// const ViewRoute = ({routeId,selectedData}) => {
const ViewRouteInstalls = () => {
  const location = useLocation()
  const routeId = location.state?.routeId // assigned_sales_order
  const selectedData = location.state?.selectedData // route row data
  const isFromPs = location.state?.isPs // true
  const [mapLoaded, setMapLoaded] = useState(false)
  const [tspSolution, setTspSolution] = useState([])
  const [apiLoaded, setApiLoaded] = useState(false)
  const [loading, setLoading] = useState(true)
  const [selectedSalesOrder, setSelectedSalesOrder] = useState(null)
  const [selectedRoute, setSelectedRoute] = useState(routeId)
  const [routeData, setRouteData] = useState([])
  const [driverData, setDriverData] = useState([])
  const [locations, setLocations] = useState([])
  const [directions, setDirections] = useState([])
  const [allDirections, setAllDirections] = useState([]) // Array to store multiple directions
  const [center, setCenter] = useState()
  const [home, setHome] = useState()
  const { google } = window
  const [currentLocation, setCurrentLocation] = useState(null)
  const userData = JSON.parse(localStorage.getItem('user'))
  const userId = userData.user_id
  const userType = userData.user_type
  const { enqueueSnackbar } = useSnackbar()
  const [totalDistance, setTotalDistance] = useState(0)
  const [nearestDistance, setNearestDistance] = useState(0)
  const [fetchingData, setFetchingData] = useState(false)
  const [filteredLocations, setFilteredLocations] = useState([])
  const [value, setValue] = useState('1')
  const [viewRoute, setViewRoute] = useState(false)
  console.log('isFromPs', isFromPs)
  useEffect(() => {
    setSelectedRoute(routeId)
  }, [routeId])




  const handleUpdateProductsAddress = async (data) => {
    console.log('productsssssssss' , data)
    try {
      const response = await axios.post(`${REST_API_END_POINT}rfq/update-products-route`, data);
      if (response.data.status === 1) {
        if(data?.address){
        enqueueSnackbar(response.data.message, { variant: "success" });
        }
        console.log('handleUpdateProductsAddress response', response.data.message);
      } else {
        if(data?.address){
        enqueueSnackbar(response.data.message, { variant: "error" });
        }
        console.log('handleUpdateProductsAddress response', response.data.message);
      }
    } catch (error) {
      console.log("Server error:", error);
      if(data?.address){
      enqueueSnackbar("Server error", { variant: "error" });
      }
      console.log('handleUpdateProductsAddress response', response.data.message);
    }
  };
  const handleUpdateServiceAddress = async (data) => {
    console.log("view dataaaa>",data)
    try {
      const response = await axios.post(`${REST_API_END_POINT}rfq/update-service-route`, data);
      if (response.data.status === 1) {
        if(data?.address){
        enqueueSnackbar(response.data.message, { variant: "success" });
        }
        console.log('handleUpdateServiceAddress response', response.data.message);
      } else {
        if(data?.address){
        enqueueSnackbar(response.data.message, { variant: "error" });
        }
        console.log('handleUpdateServiceAddress response', response.data.message);
      }
    } catch (error) {
      console.log("Server error:", error);
      if(data?.address){
      enqueueSnackbar("Server error", { variant: "error" });
      }
      console.log('handleUpdateServiceAddress response', response.data.message);
    }
  };

  const getLatandLongFromAddress = async (address) => {
  try {
    const response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${MAPBOX_ACCESS_TOKEN}`
    )
    const data = await response.json()

    if (data.features && data.features.length > 0) {
      const [lng, lat] = data.features[0].geometry.coordinates
      return {
        Latitude: Number(lat),
        Longitude: Number(lng),
      }
    } else {
      console.error('Mapbox: No results found for address:', address)
      return null
    }
  } catch (error) {
    throw new Error('Mapbox geocoding failed. ' + error.message)
  }
}
  // const generateRandomColor = () => {
  //   const letters = '0123456789ABCDEF'
  //   let color = '#'
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)]
  //   }
  //   return color
  // }

// const generateRandomColor = (num) => {
//   console.log('generateRandomColornum 2', num)
//   const randomHue = () => {
//     let hue;
//     do {
//       hue = Math.floor(Math.random() * 360);
//     } while (
//       (hue >= 0 && hue <= 20) ||      // exclude red
//       (hue >= 80 && hue <= 160) ||   // exclude green
//       (hue >= 340 && hue <= 360)     // also red wraparound
//     );
//     return hue;
//   };



//   const hue = randomHue();
//   const saturation = Math.floor(60 + Math.random() * 30); // 60–90%
//   const lightness = Math.floor(40 + Math.random() * 30);  // 40–70%

//   return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
// };

  const generateRandomColor = (num) => {
  console.log('generateRandomColor 2 ', num)
  const hue = Math.floor(Math.random() * 360);                  // Hue: 0–359
  const saturation = 50 + Math.floor(Math.random() * 50);       // Saturation: 50%–100%
  const lightness = 30 + Math.floor(Math.random() * 40);        // Lightness: 30%–70%
  
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

  const fetchAllDrivers = async () => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}driver/get-all-verified-active-drivers`,
      )
      if (response.data.status === 1) {
        setDriverData(response.data.drivers)
        console.log('Fetch drivers - ', response.data)
      } else {
        setDriverData([])
      }
    } catch (error) {
      console.log('Error fetching drivers : ', error)
    }
  }

  useEffect(() => {
    if (!home) {
      fetchDetails()
    }
    fetchAllDrivers()
  }, [home])



  const fetchDetails = async () => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}settings/get-companyProfile-details`,
      )
      if (res.data.status === 1) {
        const companyAddressData = res.data.data[0]
        const { address, city, state, zipcode,lat,lng ,id} = companyAddressData
        const fullAddress = `${address}, ${city}, ${state}, ${zipcode}`

        console.log('Company Address----', fullAddress)
        if(!lat && !lng){
          const latLong = await getLatandLongFromAddress(fullAddress)
          const { Latitude, Longitude } = latLong
          setCenter({ lat: Number(Latitude), lng: Number(Longitude) })
          setHome({ lat: Number(Latitude), lng: Number(Longitude) })
          if(Latitude && Longitude){
            console.log('productsssssssss 3')
            await handleUpdateCompanyAddress({
              id: id,
              lat:Latitude,
              lng:Longitude,
            })}

        }else{
          setCenter({ lat: Number(lat), lng: Number(lng) })
          setHome({ lat: Number(lat), lng: Number(lng) })
        }
        // if ("geolocation" in navigator) {
        //   navigator.geolocation.getCurrentPosition(
        //     position => {
        //       const { latitude, longitude } = position.coords;
        //       console.log('Current latitude:',latitude);
        //       console.log('Current longitude : ',longitude);
        //       setCenter({ lat:latitude, lng:longitude });
        //     },
        //     error => {
        //       console.error("Error getting user's location:", error);
        //     }
        //   );
        // } else {
        //   console.error("Geolocation is not supported by this browser.");
        // }
      }
    } catch (error) {
      console.log(error, 'errrrrrr')
    }
  }

  const handleUpdateCompanyAddress = async (data) => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}settings/update-company-lat-lng`, data);
      if (response.data.status === 1) {
        // enqueueSnackbar(response.data.message, { variant: "success" });
        console.log('handleUpdateCompanyAddress success', response.data.message)
      } else {
        // enqueueSnackbar(response.data.message, { variant: "error" });
        console.log('handleUpdateCompanyAddress failed', response.data.message)
      }
    } catch (error) {
      console.log("Server error:", error);
      // enqueueSnackbar("Server error", { variant: "error" });
      console.log('handleUpdateCompanyAddress error', response.data.message)
    }
  };

  useEffect(() => {
    fetchDetails()
  }, [])



  useEffect(() => {
    console.log('locations===========', locations)
    const loadMap = async () => {
      try {
        if (!window.google || !window.google.maps) {
          throw new Error('Google Maps API is not loaded')
        }

        const tspSolution = tspSolver(locations)
        setTspSolution(tspSolution)

        const orderedLocations = tspSolution.map((index) => locations[index])

        const waypoints = [
          { location: home, stopover: true },
          ...orderedLocations.map((location) => ({
            location: { lat: location?.lat, lng: location?.lng },
            stopover: true,
          })),
          { location: home, stopover: true },
        ]

        const origin = waypoints[0]?.location
        const destination = waypoints[waypoints.length - 1]?.location

        const directionsService = new window.google.maps.DirectionsService()

        directionsService.route(
          {
            origin,
            destination,
            waypoints: waypoints.slice(1, waypoints.length - 1),
            travelMode: 'DRIVING',
          },
          (result, status) => {
            if (status === 'OK') {
              setAllDirections((prev) => [...prev, { result, type: 'forward' }])

              // Calculate total distance
              let distance = 0
              result.routes[0].legs.forEach((leg) => {
                distance += leg.distance.value // Distance in meters
              })
              setTotalDistance((distance / 1000).toFixed(2)) // Convert to km and fix to 2 decimal points
            } else {
              console.error(`Forward route request failed: ${status}`)
            }
          },
        )
      } catch (error) {
        console.error('Error loading routes:', error)
      }
    }

    if (mapLoaded && apiLoaded) {
      loadMap()
    }
  }, [mapLoaded, apiLoaded, locations])

  const calculateNearestInstallation = () => {
    if (!home || locations.length === 0) return

    let minDistance = Infinity
    locations.forEach((location) => {
      const distance = calculateDistance(home, location)
      if (distance < minDistance) {
        minDistance = distance
      }
    })

    setNearestDistance(minDistance.toFixed(2)) // Fix to 2 decimal points
  }

  const filterLatestMarkers = (locations) => {
    const uniqueLocations = new Map()

    locations.forEach((location, index) => {
      const key = `${location.lat},${location.lng}`
      uniqueLocations.set(key, { ...location, index: index + 1 }) // Overwrite to keep the latest marker
    })

    return Array.from(uniqueLocations.values())
  }

  useEffect(() => {
    if (home && locations.length > 0) {
      calculateNearestInstallation()
    }
    if (locations) {
      const uniqueMarkers = filterLatestMarkers(locations)
      setFilteredLocations(uniqueMarkers)
    }
  }, [home, locations])


  const [loadingEdit, setLoadingEdit] = useState(false)
  const [selectedProducts, setSelectedProducts] = useState([])
  const [selectedServices, setSelectedServices] = useState([])
  const [additionalSelectedServices, setAdditionalSelectedServices] = useState(
    [],
  )
  const [rfpProduct, setRfpProduct] = useState([])
  const [rfpServices, setRfpServices] = useState([])
  const [details, setDetails] = useState(null)
  const [allAttachments, setAllAttachments] = useState(null)
  const [locationDetails, setLocationDetails] = useState([])
  const [render, setRender] = useState(false)
  console.log('viewroute---selectedProducts----',selectedProducts);
  console.log('viewroute---selectedServices----',selectedServices);
  console.log('viewroute---additionalSelectedServices----',additionalSelectedServices);
  console.log('viewroute---rfpProduct----', rfpProduct)
  console.log('viewroute---rfpServices----', rfpServices)
  console.log('viewroute---attachments', allAttachments)
  // console.log('viewroute---location----',locationDetails);

  useEffect(() => {
    fetchRequestDetails()
  }, [routeId])

  useEffect(() => {
    if (selectedProducts.length > 0) {
      const extractedLocations = selectedProducts.flatMap(
        (product) => product.location || [],
      )

      setLocationDetails(extractedLocations)
      if (extractedLocations?.length > 0) {
        setRender(!render)
      }
    }
  }, [selectedProducts])

  const fetchRequestDetails = async () => {
    try {
      setLoadingEdit(true)
      const res = await axios.post(`${REST_API}webservice/view-request`, {
        request_id: routeId,
        userId,
        userType,
      })
      setDetails(res.data?.data[0])
      const attachments = res.data?.attachments || null;
      setAllAttachments(attachments)
      const requestData = res.data?.data?.[0] || {}
      const invoiceData = await fetchOrderProductDetails(requestData?.id)

      const allProducts = res.data.products || []
      const allMaterials =
        res.data.materials?.map((mat) => ({
          ...mat,
          markup: Number(mat.retail_price || 0),
        })) || []
      const newAllProducts = [...allProducts, ...allMaterials]
      console.log('invoiceData---?.cust_product----', invoiceData?.cust_product)
      console.log('invoiceData---newAllProducts----', newAllProducts)

      // Extracting product data
      const extractedProducts = invoiceData?.cust_product
        ?.filter(prodItem => Array.isArray(prodItem?.location) && prodItem.location.length > 0 && prodItem.rfp == 0)
        ?.map((row) => {
          const match = newAllProducts.find(
            (data) => data.id === row.product_id,
          )
          return match
            ? {
                ...match,
                indexId: row.product_index,
                customer_order_product_id:row.id,
                product_notes: row.product_notes,
                discount: row.discount,
                adjustment: row.adjustment,
                quantity: row?.is_single_card === 0 ? 1 :row.locationQuantity,
                location: row.location,
                attachments: attachments || row.attachments,
                locationQuantity: row.locationQuantity,
                markAdjType: row.markAdjType,
                fromMapServices: row.map_service === 1,
              }
            : undefined
        })
        .filter(Boolean)

      setSelectedProducts(extractedProducts)
      if (extractedProducts?.length >0) {
        setRender(!render)
      }

      // Extracting RFP products
      const extractedRfpProduct = invoiceData?.cust_product?.filter(
        (row) => row.rfp === 1 && row.material === 0,
      )
      const updatedRfpProduct = await Promise.all(
        extractedRfpProduct?.map(async (item) => {
          console.log('productsssssssss 1' , item)
          let lat = item.lat ? parseFloat(item.lat) : null;
          let lng = item.lng ? parseFloat(item.lng) : null;
          let color = item.location[0].color || generateRandomColor(4);
      
          // Extract address fields from both item and its location array (if available)
          let address = item.address || "";
          let city = item.city || "";
          let state = item.state || "";
          let zip = item.zip || "";
      
          if (item.location?.length > 0) {
            const locationData = item.location[0]; // Assuming we take the first location object
            address = locationData.address || address;
            city = locationData.city || city;
            state = locationData.state || state;
            zip = locationData.zip || zip;
            lat = locationData.lat || lat;
            lng = locationData.lng || lng;
          }
      
          if (!lat || !lng) {
            console.log('productsssssssss 2')
            const productAddress = `${address}, ${city}, ${state}, ${zip}`;
            try {
              let latLong = await getLatandLongFromAddress(productAddress);
      
              lat = latLong?.Latitude || lat;
              lng = latLong?.Longitude || lng;
              if(lat && lng){
                console.log('productsssssssss 3')
                await handleUpdateProductsAddress({
                  // order_id: item?.customer_order_product_id || item?.id,
                  location_id: item?.id,
                  lat:lat,
                  lng:lng,
                })}
            } catch (error) {
              console.error("Error fetching lat/long:", error);
            }
          }
      
          return {
            ...item,
            lat,
            lng,
            color,
            address,
            city,
            state,
            zip,
          };
        })
      );
      console.log('updated jobs >>' , updatedRfpProduct)
      setRfpProduct(updatedRfpProduct)
      if (updatedRfpProduct?.length > 0) {
        setRender(!render)
      }
      // Extracting service data
      const extractedServices = invoiceData?.cust_product?.flatMap(
        (product) => {
          return product.services.map((service) => ({
            ...service,
            productIndex: product.product_index,
            product_id: product.product_id,
            qtyData: product?.quantity,
            quantity:product.locationQuantity || 1,
            fromMapServices: product.map_service === 1,
            locationQuantity: product?.locationQuantity || 1,
          }))
        },
      )

      setSelectedServices(extractedServices)

      // Extracting additional services
      let newIndexCounter = 0
      const additionalServices =
        res.data.requestServices?.filter((item) => item.recipe_id === null && item.rfp != 1) ||
        []
      const additionalServicesData = additionalServices.filter((item) => item.makeInstallCard === 1).map((serviceItem) => {
        console.log("serviceItem",serviceItem)
        newIndexCounter++
        return {
          ...serviceItem,
          indexId: newIndexCounter,
          productId: serviceItem.labour_cost_service_id,
          location: [
            {
              address: serviceItem.address,
              city: serviceItem.city,
              state: serviceItem.state,
              zip: serviceItem.zip,
            },
          ],
        }
      })
      console.log("serviceItem2",additionalServicesData)
      setAdditionalSelectedServices(additionalServicesData)
      if (additionalServicesData?.length > 0) {
        setRender(!render)
      }

      // Extracting RFP services
      // const extractedRfpServices = res.data.requestServices?.filter(item => item.recipe_id === null && item.rfp === 1)?.map(serviceItem => ({
      //   ...serviceItem,
      //   addresses: [
      //     {
      //       address: serviceItem.address,
      //       city: serviceItem.city,
      //       state: serviceItem.state,
      //       zip: serviceItem.zip,
      //     }
      //   ],

      // })) || [];
      const extractedRfpServices =
        res.data.requestServices
          ?.filter((item) => item.recipe_id === null && item.rfp === 1 && item.makeInstallCard === 1)
          ?.map((serviceItem) => ({
            ...serviceItem,
            addresses: [
              {
                address: serviceItem.address,
                city: serviceItem.city,
                state: serviceItem.state,
                zip: serviceItem.zip,
              },
            ],
          })) || []
      const updatedRfpServices = await Promise.all(
        extractedRfpServices.map(async (item) => {
          const serviceId = item?.id
          console.log("rfp servicessss1 >",item)
          let lat = item.lat ? parseFloat(item.lat) : null
          let lng = item.lng ? parseFloat(item.lng) : null
          let serviceAddress = ''
          let color = item.color || generateRandomColor(5)

          if (!lat || !lng) {
            console.log("rfp servicessss2 >")
            serviceAddress = `${item?.address}, ${item?.city}, ${item?.state}, ${item?.zip}`
            try {
              let latLong = await getLatandLongFromAddress(serviceAddress)
              console.log('rfpservice--latlong---',latLong);
              
              lat = latLong?.Latitude || lat
              lng = latLong?.Longitude || lng
              if(lat && lng){
                console.log("rfp servicessss3 >",serviceId)
                await handleUpdateServiceAddress({
                  service_id: serviceId,
                  lat:lat,
                  lng:lng,
                  is_lat_lng:true
                });
              }
            } catch (error) {
              console.error('Error fetching lat/long:', error)
            }
          }

          return {
            ...item,
            lat,
            lng,
            color,
          }
        }),
      )

      setRfpServices(updatedRfpServices)
      if (updatedRfpServices?.length > 0) {
        setRender(!render)
      }
      console.log('setRfpServices>>>', extractedRfpServices)
    } catch (error) {
      console.error('Error fetching request details:', error)
    } finally {
      setLoadingEdit(false)
    }
  }

  const fetchOrderProductDetails = async (order_id) => {
    try {
      setLoadingEdit(true)
      let orderId = routeId || details?.id || order_id

      if (orderId) {
        const res = await axios.post(
          `${REST_API}webservice/get-customer-order-product/${orderId}`,
        )
        return res?.data?.data || []
      }
    } catch (error) {
      console.error('Error fetching order product details:', error)
    } finally {
      setLoadingEdit(false)
    }
  }

  // useEffect(async () => {
  //   if (selectedSalesOrder) {
  //     const directionsPromises = [selectedSalesOrder]?.map(
  //       async (route, index) => {
  //         const installations = await fetchInstallationByRoute(
  //           route.appointments,
  //         )
  //         if (installations.length >= 1) {
  //           setLocations(installations)
  //           const waypoints = [
  //             { location: home, stopover: true }, // Add home as the first location
  //             ...installations.map((location) => ({
  //               location: { lat: location.lat, lng: location.lng },
  //               stopover: true,
  //             })),
  //             { location: home, stopover: true }, // Add home as the last location
  //           ]
  //           const origin = waypoints[0]?.location
  //           const destination = waypoints[waypoints.length - 1]?.location

  //           const directionsService = new window.google.maps.DirectionsService()
  //           return new Promise((resolve, reject) => {
  //             directionsService.route(
  //               {
  //                 origin,
  //                 destination,
  //                 waypoints: waypoints.slice(1, waypoints.length - 1),
  //                 travelMode: 'DRIVING',
  //               },
  //               (result, status) => {
  //                 if (status === 'OK') {
  //                   resolve({ result, index })
  //                 } else {
  //                   reject(
  //                     `Directions request failed for route ${
  //                       index + 1
  //                     }: ${status}`,
  //                   )
  //                 }
  //               },
  //             )
  //           })
  //         }
  //       },
  //     )

  //     const directionsResults = await Promise.all(directionsPromises)
  //     setAllDirections(directionsResults.filter((d) => d !== undefined))
  //   }
  // }, [selectedSalesOrder])

  const containerStyle = {
    // display: 'flex',
    // flexDirection: 'row',
    // justifyContent: 'space-between',
    // alignItems: 'center',
    marginBottom: 10,
    position: 'absolute',
    right: '10px',
    width: '260px',
  }
  const subcontainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: -35,
  }
  let i = 0

  return (
    <Stack spacing={3}>
      <Box
        sx={{
          p: 2,
          mt: 2,
          height: 'fit-content',
          width: '100%',
          borderRadius: 1,
          // bgcolor: 'grey.50012'
        }}
      >
        <MapComponent2
          allAttachments={allAttachments}
          driverDataaa={driverData}
          home={home}
          selectedSalesOrder={selectedSalesOrder}
          setSelectedSalesOrder={setSelectedSalesOrder}
          selectedRoute={selectedRoute}
          setSelectedRoute={setSelectedRoute}
          locations={locations}
          setLocations={setLocations}
          directions={directions}
          setDirections={setDirections}
          getLatandLongFromAddress={getLatandLongFromAddress}
          selectedData={selectedData}
          isFromPs={isFromPs}
          locationDetails={locationDetails}
          requestProducts={selectedProducts}
          setRequestProducts={setSelectedProducts}
          additionalSelectedServices={additionalSelectedServices}
          setAdditionalSelectedServices={setAdditionalSelectedServices}
          selectedRfpServices={rfpServices}
          setSelectedRfpServices={setRfpServices}
          selectedRfpProduct={rfpProduct}
          setSelectedRfpProduct={setRfpProduct}
          render={render}
          details={details}
        />
      </Box>
    </Stack>
  )
}

export default ViewRouteInstalls
